VLW.controllers.eavVin = class extends VLW.controllers.Home {
	constructor(a, b) {
		super(a, b);
		this.pixi.align            = "tl";
		this.pixi.displacementType = VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_HOME;
		this.constructor.setStyleMenuHover("color_gris");
		window.addEventListener("resize", this.onResize);
		this.millesimeLabel = this.qs("._millesimeLabel");
		this.millesimeLabel && 	this.millesimeLabel.addEventListener("mouseenter"	,this.onEnterMillesime);
		this.millesimeLabel && 	this.millesimeLabel.addEventListener("click"		,this.onEnterMillesime);
		this.millesimeLabel && 	this.qs("header").addEventListener("mouseleave"		,this.onLeaveMillesime);
		this.millesimeLabel && 	this.qs("header").addEventListener("click"			,this.onLeaveMillesime);
		this.bouteilleContainer = this.qs("[data-vlw-autovars='imgContainer']");
		
		if(this.bouteilleContainer){
			this.bouteilleContainerClone = this.bouteilleContainer.cloneNode(true);
			this.bouteilleContainerClone.classList.add("__clone");
			this.bouteilleContainer.parentNode.insertBefore(this.bouteilleContainerClone,this.bouteilleContainer);
			document.body.appendChild(this.bouteilleContainer);
			this.placeBouteillePixi();
		}
		
	
		//_listeMillesime
	}
	onEnterMillesime(e){
		e.stopPropagation();
		TweenMax.killTweensOf(this.qsa("._listeMillesime,._listeMillesime li,header h1,header h2,header ._btnBack ,header ._btnPDF"));
		let tl = new TimelineMax();
		tl.to(this.qsa("header h1,header h2,header ._btnBack ,header ._btnPDF"),.5,{opacity:0,pointerEvents:"none"},0);
		tl.set(this.qsa("._listeMillesime"),{pointerEvents:"auto"},0);
		tl.staggerTo(this.qsa("._listeMillesime li"),.5,{opacity:1,ease:Power2.easeIn,},.05,0);
	}
	onLeaveMillesime(){
		TweenMax.killTweensOf(this.qsa("._listeMillesime,._listeMillesime li,header h1,header h2,header ._btnBack ,header ._btnPDF"));
		let tl = new TimelineMax();
		tl.staggerTo(this.qsa("header h1,header h2,header ._btnBack ,header ._btnPDF"),.5,{opacity:1,pointerEvents:"auto",ease:Power2.easeIn},.1,0);
		tl.set(this.qsa("._listeMillesime")			,{pointerEvents:"none"},0);
		tl.staggerTo(this.qsa("._listeMillesime li"),.35,{opacity:0,ease:Sine.easeOut,},.025,0);
	}
	
	onResize(e) {
		this.placeBouteillePixi(true);
	}
	
	placeBouteillePixi(instant = false) {
		if (!window.containerBouteille|| !this.bouteilleContainer) {
			return;
		}
		let _time  = instant ? 0 : 2.5;
		let _delay = instant ? 0 : 0;
		let _bound = this.bouteilleContainer.querySelector("img").getBoundingClientRect();
		if(_bound.width!==0) {
			TweenMax.to(window.containerBouteille, _time, {pixi: {x: _bound.x, y: _bound.y, width: _bound.width, height: _bound.height},onComplete:this.onCompletePlaceBouteillePixi, delay: _delay, ease: Power2.easeInOut});
		}else{
			clearTimeout(this.idPlaceBout );
			this.idPlaceBout = setTimeout(this.placeBouteillePixi,250);
		}
	}
	onCompletePlaceBouteillePixi(){
		TweenMax.to(this.bouteilleContainer, .5, {opacity: 1,  ease: Power2.easeIn});
		window.bouteilleContainer && (TweenMax.to(window.bouteilleContainer, .5, {alpha: 0}));
	}
	
	intro(delay = getDelayIntro()) {
		this.vlwFiche = new VLW.vin.Fiche(this);
		super.intro();
	}
	
	introContent(delay = 0) {
		delay = VERSION_SMARTP?{delay:0}:delay;
		let _delayBouteille = VERSION_SMARTP?0:1.5;
		let tl = new TimelineMax({delay});
		tl.set(this.mainElementJS, {opacity: 1});
		tl.addLabel("start");
		tl.fromTo(this.qsa("._logoVin"), 1.25, {rotationX: 35, transformOrigin: "0% 0%", opacity: 0}, {rotationX: 0, opacity: 1, ease: Sine.easeInOut}, "start");
		tl.add(this.animFilet(), "start");
		tl.addLabel("texte", "-=1");
		tl.fromTo(this.qs("h2")							, .75	, {opacity: 0}, {opacity: 1, ease: Sine.easeIn}, "texte+=0");
		tl.fromTo(this.qsa("[class*='_btn']")			, 1		, {opacity: 0}, {opacity: 1, ease: Sine.easeIn}, "texte+=0");
		tl.fromTo(this.qsa("._doubleFilet ")			, 1		, {opacity: 0}, {opacity: 1, ease: Sine.easeIn}, "texte-=1");
		tl.fromTo(this.qsa(".vlwScroll")				, 1		, {opacity: 0}, {opacity: 1, ease: Sine.easeIn}, "texte-=1");
		(!window.containerBouteille || VERSION_SMARTP) && tl.fromTo(this.bouteilleContainer, .75, {opacity: 0}, {opacity: 1, delay: _delayBouteille, ease: Power2.easeIn}, "texte-=1.5");
		tl.staggerFromTo(this.mySplitText.chars	, .75	, {opacity: 0}, {opacity: 1, ease: Sine.easeIn}, .25 * .5, "texte-=2");
		tl.staggerFromTo(this.mySplitText.chars	, 1		, {y: 15, rotation: 2.5, transformOrigin: "50% 0%"}, {smoothOrigin: true, rotation: 0, transformOrigin: "0% 0%", y: 0, ease: Sine.easeOut}, .15 * .5, "texte-=2");
		return true;
	}
	
	loadPIXIResources(force = false) {
		if(this.mainElementJS.getAttribute("data-background")) {
			let _loader = new PIXI.loaders.Loader();
			_loader.add("image"				, this.getPIXIResourcesBackground());
			_loader.load((loader, resources) => {
				this.pixi && (this.pixi.resources = resources);
				loader.destroy()
			});
		}
	}
	
	onMenuHover() {
		super.onMenuHover();
		TweenMax.to(this.bouteilleContainer, .5, {opacity: 0});
	}
	
	onMenuLeave() {
		super.onMenuLeave();
		TweenMax.to(this.bouteilleContainer, .75, {opacity: 1, delay: .25, ease: Power2.easeIn});
	}
	
	outro() {
		TweenMax.killTweensOf(this.bouteilleContainer);
		TweenMax.killDelayedCallsTo(this.loadPIXIResources);
		TweenMax.to(this.bouteilleContainer, .5, {opacity: 0, onComplete: (elt) => {removeNode(elt)}, onCompleteParams: [this.bouteilleContainer]});
		
		this.millesimeLabel && 	this.millesimeLabel.removeEventListener("mouseenter"	,this.onEnterMillesime);
		this.millesimeLabel && 	this.millesimeLabel.removeEventListener("click"			,this.onEnterMillesime);
		this.millesimeLabel && 	this.qs("header").removeEventListener("mouseleave"		,this.onLeaveMillesime);
		this.millesimeLabel && 	this.qs("header").removeEventListener("click"			,this.onLeaveMillesime);
		
		window.removeEventListener("resize", this.onResize);
		super.outro();
	}
	
	setSplitText() {
		this.mySplitText  = this.qsa("h1").length > 0 ? new SplitText(this.qsa("h1"), {type: "chars", linesClass: "_lines"}) : {lines: {}};
		this.mySplitText2 = this.qsa("._plus span,._plus a").length > 0 ? new SplitText(this.qsa("._plus span,._plus a"), {type: "chars", linesClass: "_lines"}) : null;
	}
	
	unsetBouteilleContainer() {
	
	}
	
	static getPixiOption() {
		return !VERSION_SMARTP?{"ctrl": "eavVin"}:{};
	}
};